import React from 'react';

import { serializeOffersHubPreviewPayload } from '~/utils/societePayloadBuilder/offersHub/buildPayload';
import type { OffersHubPayloadBuilderState } from '~/utils/societePayloadBuilder/offersHub/types';

import PayloadBuilderJsonPreview from '../JsonPreview';

interface OffersHubPayloadPreviewProps {
  state: OffersHubPayloadBuilderState;
  borderSoft: string;
  maxHeight: string;
}

export default function OffersHubPayloadPreview({ state, borderSoft, maxHeight }: OffersHubPayloadPreviewProps) {
  return (
    <PayloadBuilderJsonPreview
      state={state}
      serialize={serializeOffersHubPreviewPayload}
      borderSoft={borderSoft}
      maxHeight={maxHeight}
    />
  );
}
